const AnchorNavigation = () => {
    return null;
};
export default AnchorNavigation;
